// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/ProjectService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import type { ProjectDtoSchema } from "../Messages/Basic_pb";
import { file_Messages_Basic } from "../Messages/Basic_pb";
import type { ProjectCollectionDtoSchema } from "../Messages/Collections_pb";
import { file_Messages_Collections } from "../Messages/Collections_pb";
import type { UuidDtoSchema, UuidWithDeletedItemSelectionDtoSchema } from "../Messages/Common_pb";
import { file_Messages_Common } from "../Messages/Common_pb";
import type { ProjectDetailedDtoSchema } from "../Messages/Detailed_pb";
import { file_Messages_Detailed } from "../Messages/Detailed_pb";
import type { ProjectFiltersDtoSchema } from "../Messages/Filters_pb";
import { file_Messages_Filters } from "../Messages/Filters_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/ProjectService.proto.
 */
export const file_Services_ProjectService: GenFile = /*@__PURE__*/
  fileDesc("Ch1TZXJ2aWNlcy9Qcm9qZWN0U2VydmljZS5wcm90bzLYBwoOUHJvamVjdFNlcnZpY2US3gEKCkdldFByb2plY3QSPi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmNvbW1vbi5VdWlkV2l0aERlbGV0ZWRJdGVtU2VsZWN0aW9uRHRvGjMudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5Qcm9qZWN0RGV0YWlsZWREdG8iW6DazQ8CgtPkkwJQWhw6ASoiFy9hcGkvcHJvamVjdC9nZXRQcm9qZWN0EjAvYXBpL3Byb2plY3QvZ2V0UHJvamVjdC97aWQuaGlnaF82NH0ve2lkLmxvd182NH0SpAEKC0dldFByb2plY3RzEjEudGltZV90cmFja2luZy5tZXNzYWdlcy5maWx0ZXJzLlByb2plY3RGaWx0ZXJzRHRvGjgudGltZV90cmFja2luZy5tZXNzYWdlcy5jb2xsZWN0aW9ucy5Qcm9qZWN0Q29sbGVjdGlvbkR0byIooNrNDwKC0+STAh06ASoiGC9hcGkvcHJvamVjdC9nZXRQcm9qZWN0cxKaAQoNQ3JlYXRlUHJvamVjdBIoLnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuYmFzaWMuUHJvamVjdER0bxozLnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuZGV0YWlsZWQuUHJvamVjdERldGFpbGVkRHRvIiqg2s0PAILT5JMCHzoBKiIaL2FwaS9wcm9qZWN0L2NyZWF0ZVByb2plY3QS1AEKDVVwZGF0ZVByb2plY3QSKC50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmJhc2ljLlByb2plY3REdG8aMy50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmRldGFpbGVkLlByb2plY3REZXRhaWxlZER0byJkoNrNDwCC0+STAlk6ASpaHzoBKiIaL2FwaS9wcm9qZWN0L3VwZGF0ZVByb2plY3QaMy9hcGkvcHJvamVjdC91cGRhdGVQcm9qZWN0L3tpZC5oaWdoXzY0fS97aWQubG93XzY0fRLJAQoNRGVsZXRlUHJvamVjdBImLnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuY29tbW9uLlV1aWREdG8aMy50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmRldGFpbGVkLlByb2plY3REZXRhaWxlZER0byJboNrNDwCC0+STAlBaHzoBKiIaL2FwaS9wcm9qZWN0L2RlbGV0ZVByb2plY3QqLS9hcGkvcHJvamVjdC9kZWxldGVQcm9qZWN0L3toaWdoXzY0fS97bG93XzY0fUIkqgIhTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLlNlcnZpY2VzYgZwcm90bzM", [file_google_api_annotations, file_Enumerations_AuthorizationPolicy, file_Messages_Basic, file_Messages_Collections, file_Messages_Common, file_Messages_Detailed, file_Messages_Filters, file_Options_MethodOptions]);

/**
 * CRUD operations for projects.
 *
 * @generated from service ProjectService
 */
export const ProjectService: GenService<{
  /**
   * Fetch a project specified by its id.
   * Policy: Users can fetch only projects they are assigned to.
   *
   * @generated from rpc ProjectService.GetProject
   */
  getProject: {
    methodKind: "unary";
    input: typeof UuidWithDeletedItemSelectionDtoSchema;
    output: typeof ProjectDetailedDtoSchema;
  },
  /**
   * Fetch projects according to filters.
   * Policy: Users must specify only their user id in the user_ids filter.
   *
   * @generated from rpc ProjectService.GetProjects
   */
  getProjects: {
    methodKind: "unary";
    input: typeof ProjectFiltersDtoSchema;
    output: typeof ProjectCollectionDtoSchema;
  },
  /**
   * Create a new project.
   *
   * @generated from rpc ProjectService.CreateProject
   */
  createProject: {
    methodKind: "unary";
    input: typeof ProjectDtoSchema;
    output: typeof ProjectDetailedDtoSchema;
  },
  /**
   * Modify project properties.
   *
   * @generated from rpc ProjectService.UpdateProject
   */
  updateProject: {
    methodKind: "unary";
    input: typeof ProjectDtoSchema;
    output: typeof ProjectDetailedDtoSchema;
  },
  /**
   * Delete the project with the given id.
   *
   * @generated from rpc ProjectService.DeleteProject
   */
  deleteProject: {
    methodKind: "unary";
    input: typeof UuidDtoSchema;
    output: typeof ProjectDetailedDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_ProjectService, 0);

